module.exports = __webpack_public_path__ + "static/media/Brandon_reg.1f55925e.otf";